import { CharityRoute } from "../types/CharityRouteEnum";
import { LeaderboardBoard } from "../types/LeaderboardBoardEnum";
import { LeaderboardBoardTab } from "../types/LeaderboardBoardTab";

/** The board that opens when the URL names none, or names one this campaign does not serve. */
export const DEFAULT_LEADERBOARD_BOARD = LeaderboardBoard.Households;

/** The tabs above the table, in the order they are read. */
export const LEADERBOARD_BOARD_TABS: LeaderboardBoardTab[] = [
  { board: LeaderboardBoard.Households, label: "Households" },
  { board: LeaderboardBoard.Adults, label: "Adults" },
  { board: LeaderboardBoard.Minors, label: "Minors" },
];

/**
 * Read the board named by the URL hash, accepting only the boards this campaign serves.
 *
 * The hash arrives from a link anyone could have edited, so an unknown name is
 * dropped for the default rather than refused — the same rule the campaign
 * applies to the sign-in destination carried through a magic link. Nothing is
 * decoded first: every board name is plain ASCII, and decoding would let a
 * malformed escape throw where a wrong board name only has to fall back.
 *
 * @param hash - The raw `location.hash`, leading "#" included
 * @returns The board named, or Households when nothing valid was named
 */
export const parseLeaderboardBoard = (hash: string): LeaderboardBoard => {
  const named = hash.startsWith("#") ? hash.slice(1) : hash;
  const served = Object.values(LeaderboardBoard) as string[];

  return served.includes(named) ? (named as LeaderboardBoard) : DEFAULT_LEADERBOARD_BOARD;
};

/**
 * The address that opens one board.
 *
 * @param board - The board to link to
 * @returns A path within the campaign, e.g. `/charity/leaderboard#adults`
 */
export const leaderboardBoardHref = (board: LeaderboardBoard): string => `${CharityRoute.Leaderboard}#${board}`;
